module.exports = __webpack_public_path__ + "img/reservationDetails.b89c6458.svg";